"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleQuestionMark, Mail } from "lucide-react";
const faqItems = [{
  question: "What happens after I register?",
  answer: "Once your registration is complete, you will receive a confirmation email and we will contact you shortly. From there, you can begin the guided onboarding process."
}, {
  question: "What details do I need to provide during onboarding?",
  answer: "We require basic account information - name, email, phone number, country of origin. This ensures our day-to-day tracking of active subscribers is easier."
}, {
  question: "When does my subscription become active?",
  answer: "Your subscription activates immediately upon successful payment confirmation. You will gain instant access to our online community."
}, {
  question: "How do I get support if I need help?",
  answer: "Our dedicated client success team is available through multiple channels, including direct phone calls and email support. We are here to ensure your onboarding journey is smooth and efficient."
}];
export default function HelpFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21609" id="portal-faq" ref={ref} className={`dark py-16 md:py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4 shadow-[0_0_15px_rgba(59,130,246,0.2)]">
            <CircleQuestionMark className="w-5 h-5 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Client Access & Onboarding FAQ
          </h2>
          <p className="text-lg text-muted-foreground">
            Common questions about registration, onboarding, account setup, subscription activation, and client access.
          </p>
        </div>

        <div className="bg-card/30 backdrop-blur-md border border-border/50 rounded-xl shadow-2xl p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/50 last:border-0 data-[state=open]:bg-white/5 transition-colors rounded-lg px-4" data-index={i}>
                <AccordionTrigger className="text-left text-foreground hover:text-primary hover:no-underline py-5 text-base font-semibold tracking-tight transition-colors">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-border/30 shadow-inner">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            Need help with onboarding?
          </h3>
          <p className="text-muted-foreground mb-6 max-w-lg mx-auto">
            Our team is available to help you with registration, account setup, and client access.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_20px_rgba(59,130,246,0.3)] transition-all">
              <Link to="#">
                <Mail className="mr-2 h-4 w-4" />
                Contact Us
              </Link>
            </Button>
            <Button variant="outline" size="lg" asChild className="border-border hover:bg-white/5 text-foreground transition-all">
              <Link to="#">View Performance</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}